module.exports = __webpack_public_path__ + "img/HealthHelp_Biometric.b150a6c1.svg";